import api from "./axios";
import type { ChangeTariffPayload, TariffArray } from "@/struct/TariffStruct";
import type {
  ApiDataEnvelope,
  ApiResponseEnvelope,
} from "@/struct/ApiEnvelope";
import type { SubscriptionResponse } from "@/struct/SubscriptionDataStruct";

export default class TariffService {
  changeTariff = (payload: ChangeTariffPayload) => {
    return api.post("/api/ems/tariff-swap", {
      mainProductId: payload.mainProductId,
      scheduledOn: payload.scheduledOn,
    });
  };
  getOffers = async () => {
    return api.get<ApiDataEnvelope<TariffArray[]>>(
      "/api/web-api/customer/get-offers"
    );
  };
  getSubscriptionDetails = () => {
    return api.get<ApiResponseEnvelope<SubscriptionResponse>>(
      "/api/ems/get-subscription-details"
    );
  };

  applyPromo = (code: string) => {
    return api.post("/api/web-api/promo/add", { code });
  };
}
